import { render } from "./SwitchToogle.vue?vue&type=template&id=5a67e07c&scoped=true"
import script from "./SwitchToogle.vue?vue&type=script&lang=js"
export * from "./SwitchToogle.vue?vue&type=script&lang=js"

import "./SwitchToogle.vue?vue&type=style&index=0&id=5a67e07c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a67e07c"]])

export default __exports__